/* eslint-disable prettier/prettier, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-call */
import * as gql from 'fake-tag';

// Spread into the shared TemplateSingleQuery under a `referAFriendConfig` alias on the
// `aceHeader_GlobalSet` global set (ecom-craftcms-v3 EPS-4568). The RAF widget is now a site-wide
// global (mounted once in TemplateSingleComponent, not a placed block), configured once here rather
// than per page. Three fields:
//   - `referAFriendModalMessage` — the on-screen copy shown INSIDE the modal. This one IS a `{ html }`
//      CKEditor object (unlike `referAFriendMessage` below), so it MUST be sub-selected as `{ html }`.
//      `CraftQueryService.flattenCkeditorFields` then collapses a populated `{ html: <string> }` to the
//      bare html string before the container sees it (an empty one survives as `{ html: null }`). The
//      container renders it as the widget's intake copy (title + body).
//   - `referAFriendMessage` — the share message pre-filled into each channel. Despite Craft's first handoff
//      calling it a bare scalar, the live schema types it as `referAFriendMessage_CkeditorField`, so it MUST
//      be sub-selected as `{ html }` (selecting it bare 400s the shared query for every Vision brand:
//      `Field "referAFriendMessage" ... must have a sub selection`). Flatten collapses the populated
//      `{ html }` to a string; the container strips it to plain text for the share-intent hrefs.
//   - `referAFriendSocialOptions` — a `[String]` of channel ids (email, facebook, whatsapp, threads, x)
//      the author selected, in display order. The widget maps each id to its hardcoded channel.
export const ReferAFriendGlobalFragment = {
  RAF: gql`
    fragment ReferAFriendGlobalQuery on aceHeader_GlobalSet {
      referAFriendModalMessage {
        html
      }
      referAFriendMessage {
        html
      }
      referAFriendSocialOptions
    }
  `,
};
